import { UserNotificationState } from '@shared/service-proxies/service-proxies';

export class AppUserNotificationState {
    static Unread: number = UserNotificationState._0;
    static Read: number = UserNotificationState._1;
}

export class AppEditionExpireAction {
    static DeactiveTenant = 'DeactiveTenant';
    static AssignToAnotherEdition = 'AssignToAnotherEdition';
}




// WEBPACK FOOTER //
// ./src/shared/AppEnums.ts